import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const MinusIconAtom = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M6 12H18" />
	</SvgIcon>
)

export default MinusIconAtom
